/* eslint-disable complexity */
/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable camelcase */
/* eslint-disable max-depth */
import { CallEvent } from '@byted/tiktok-zti-call';
import CrossLocalStorage from './cache/storage';
import { isTopBrowser } from '@byted/tiktok-zti-storage-web';
import {
  convertStringToBase64,
  convertBase64ToString,
  convertHexToBase64,
  getPublicKeyFromCert,
  reportAsyncThunk,
  comparePublicKeyWithCert,
  generateKeysInfoMD5,
  compareAllKeysInfoMD5,
  pipeline,
  Scheduler,
  getPubKeyBase64,
  comparePublicKeyWithNewClient
} from './utils';
import SecurityCrypto from './crypto';
import { debug } from '@byted/tiktok-zti-utils';
import {
  StoreSDK,
  SecurityConfig,
  EventEmitParams,
  EventErrorParams,
  EventLogParams,
  TypeAction,
  TypeOperate,
  SignValueProps,
  CryptoValues,
  TypeAllKeysInfo,
  SecureSDKContext,
  SlardarDotParams,
  ZTIRegion
} from '@byted/tiktok-zti-types';
import { getCookie } from './utils/cookie';
import DocCookie from './cookie';
import { logFetchServerDataFromCookie } from '@byted/tiktok-zti-monitor';
import { decryptText, encryptText } from './crypto/secure-storage';

const cryptCacheKey = 's_sdk_crypt_sdk'; // 秘钥 + csr
const certificateCacheKey = 's_sdk_cert_key'; // 证书
const signDataCacheKey = 's_sdk_sign_data_key'; // server data

// const ServerDataStatus = '__security_server_data_status';

const COOKIE_CRYPT = '_tt_ticket_crypt_cookie';

const COOKIE_DOMAIN = '_tt_ticket_crypt_doamin';

class CryptoSDK extends CallEvent<{
  load: EventEmitParams;
  ready: EventEmitParams;
  execute: EventEmitParams;
  error: EventErrorParams;
  log: EventLogParams;
}> {
  config!: SecurityConfig;
  storeType?: 'iframe' | 'local';
  updateKeys?: boolean;
  cryptoSDK?: SecurityCrypto;
  setSignValueScheduler?: Scheduler;
  signType?: 'cert' | 'pubKey' = 'pubKey';
  initType?: 'cert' | 'pubKey' = 'pubKey';
  cookieOperate?: DocCookie;
  initMatch!: boolean;
  private _disableCrossStorage?: boolean;
  private _disableStorageSignData?: boolean;
  private _signData?: string;
  private _storageNamespace?: string;
  // 后续serverData 不删除时使用
  // private _serverDataCache?: string;
  private _storeSDK?: StoreSDK;
  private _cryptData?: string;
  private _cryptObject?: CryptoValues;
  private _iframeURL?: string;
  private _iframeBackURL?: string;
  private _initData!: { [key: string]: string | undefined };
  private _region?: ZTIRegion;

  private _hasProcessServerData?: boolean;
  private loadIframePromise?: Promise<any>;
  private initConfig!: { sendEvent: (config: SlardarDotParams) => void };
  constructor(params: { sendEvent: (config: SlardarDotParams) => void }) {
    super();
    this.initConfig = params;
    this.setSignValueScheduler = new Scheduler();
    this._initData = {};
    this._hasProcessServerData = false;
    this.initMatch = false;
  }

  setRegion = (region: ZTIRegion) => {
    this._region = region;
  };
  /**
   * 设置当前加签 or 生成模式
   */
  setType = (params: { initType: 'cert' | 'pubKey'; signType: 'cert' | 'pubKey' }) => {
    const { initType = 'pubKey', signType = 'pubKey' } = params;
    this.signType = signType;
    this.initType = initType;
  };

  /**
   * 设置当前存储类型 { @deprecated }
   * @param type 当前存储类型
   */
  setStorageType = (type: 'iframe' | 'local') => {
    if (this.storeType && type !== this.storeType) {
      throw new Error('secure sdk only one storage type, please set correct type!');
    } else {
      this.storeType = type;
    }
  };

  /**
   * 确定是否需要存储SignData，如果不需要存储的话，这边就会保存在内存里面不存储到storage中
   * 场景： im-token 多tab之间token不同，tsSign不同，获取tsSign的时候只是使用内存中的数据
   * @param disable 是否需要存储signData
   */
  setDisableStorageSignData = (disable: boolean) => {
    this._disableStorageSignData = disable;
  };

  /**
   * 设置当前iframeurl
   * @param url string
   */
  setCrossStorageURL = (url: string) => {
    this._iframeURL = url;
  };

  /**
   * 设置当前fallback iframe url
   * @param url string
   */
  setCrossStorageBackURL = (url: string) => {
    this._iframeBackURL = url;
  };

  /**
   * 设置是否允许加载iframe 全局单实例默认加载，当多实例时判断是否需要
   * @param disable boolean
   */
  setDisableCrossStorage = (disable: boolean) => {
    this._disableCrossStorage = disable;
  };

  /**
   * 设置当前存储秘钥的namespace
   * @param name string
   */
  setStorageNamespace = (name: string) => {
    this._storageNamespace = name;
  };

  /**
   * 设置同步秘钥配置
   * @deprecated
   * @param update 是否需要同步秘钥
   */
  setUpdateKeys = (update: boolean) => {
    this.updateKeys = update;
  };

  /**
   * 设置当前全局配置
   * @param config 当前配置
   */
  setConfig = (config: SecurityConfig) => {
    this.config = config;
  };

  /**
   * 新增统一配置入口把所有的配置放在一个方法里面
   * @param context object
   */
  setContext = (context: SecureSDKContext) => {
    const {
      disableCrossStorage = false,
      updateKeys = false,
      storageNamespace,
      iframeBackURL,
      iframeURL,
      signType = 'pubKey',
      initType = 'pubKey',
      storeType = 'iframe',
      disableStorageSignData = false
    } = context;
    this.signType = signType;
    this.initType = initType;
    this._disableCrossStorage = disableCrossStorage;
    this._storageNamespace = storageNamespace;
    this._iframeBackURL = iframeBackURL;
    this._iframeURL = iframeURL;
    this.updateKeys = updateKeys;
    this.storeType = storeType;
    this._disableStorageSignData = disableStorageSignData;
  };

  /**
   * 开启初始化方法
   */
  start = () => {
    Object.keys(this.config || {}).forEach((ele) => {
      const configArray = this.config?.[ele];
      const secureConfig = Array.isArray(configArray) && configArray.length > 0 && configArray[0];
      const { scene = '', certType } = secureConfig || {};
      this.initIframeKeys(scene);
      if (certType === 'cookie') {
        this._initCookie(scene);
      }
      // certType === 'request' 取消，不再使用
      if (certType === 'request') {
        console.warn('certType === request is deprecated');
      }
    });
  };

  /**
   * 初始化当前iframe 存储
   */
  private initIframeStore = () => {
    const url = this._iframeURL;
    if (!this._storeSDK) {
      this.cookieOperate = new DocCookie();
      this.cookieOperate?.on('error', (args) => {
        this.emit('error', args);
      });
      const { sendEvent } = this.initConfig || {};
      const cacheSDk = new CrossLocalStorage({
        url,
        fallbackCacheOriginURL: this._iframeBackURL,
        sendEvent,
        disableCrossStorage: this._disableCrossStorage,
        namespace: this._storageNamespace,
        region: this._region
      });
      this.loadIframePromise = cacheSDk.loadIframePromise;
      cacheSDk.on('error', (arg: EventErrorParams) => {
        this.emit('error', arg);
      });
      cacheSDk.on('load', (args: EventEmitParams) => {
        this.emit('load', args);
      });
      cacheSDk.on('execute', (args: EventEmitParams) => {
        this.emit('execute', args);
      });
      cacheSDk.on('log', (args: EventLogParams) => {
        this.emit('log', args);
      });
      const cacheProps: StoreSDK = {
        get: reportAsyncThunk(
          cacheSDk.getItem,
          'iframe get item error',
          this.reportError,
          'getItem',
          'storage',
          this.storeType
        ),
        set: reportAsyncThunk(
          cacheSDk.setItem,
          'iframe set item error',
          this.reportError,
          'setItem',
          'storage',
          this.storeType
        ),
        delete: reportAsyncThunk(
          cacheSDk.deleteItem,
          'iframe delete item error',
          this.reportError,
          'deleteItem',
          'storage',
          this.storeType
        ),
        getItems: reportAsyncThunk(
          cacheSDk.getItemWithKeys,
          'iframe get items keys error',
          this.reportError,
          'getKeys',
          'storage',
          this.storeType
        ),
        setItems: reportAsyncThunk(
          cacheSDk.setItemWithKeys,
          'iframe set items keys error',
          this.reportError,
          'setKeys',
          'storage',
          this.storeType
        ),
        getItemsWithOrigin: reportAsyncThunk(
          cacheSDk.getItemsWithOrigin,
          'iframe get items keys with origin error',
          this.reportError,
          'getKeys',
          'storage',
          this.storeType
        ),
        getLocalItem: reportAsyncThunk(
          cacheSDk.getLocalItem,
          'localstorage get item keys error',
          this.reportError,
          'getItem',
          'localstorage',
          this.storeType
        ),
        setLocalItem: reportAsyncThunk(
          cacheSDk.setLocalItem,
          'localstorage set item keys error',
          this.reportError,
          'setItem',
          'localstorage',
          this.storeType
        ),
        getLocalItems: reportAsyncThunk(
          cacheSDk.getLocalItemsWithKeys,
          'localstorage set item keys error',
          this.reportError,
          'setItem',
          'localstorage',
          this.storeType
        ),
        getIframeStatus: cacheSDk.getIframeStatus,
        getStorageStatus: cacheSDk.getStorageStatus,
        startStorageChecker: cacheSDk.startStorageChecker
      };
      this._storeSDK = cacheProps;
    }
  };

  /**
   * 初始化秘钥 publicKey privateKey & csr
   */
  private initIframeKeys = (scene: string) => {
    this.initIframeStore();
    this._checkCryptKeys(scene);
  };

  /**
   * 处理当前cookie clent_data & server_data
   * 使用pipeline包裹后，可以缓存结果，一个生命周期只会执行一次
   * @param scene 当前scene， 设置cookie用
   */
  private _initCookie = pipeline(async (scene: string) => {
    try {
      await this._processServerCookie(scene);
      await this._processCookie(scene);
      return true;
    } catch (error) {
      this.reportError(error, 'Init Cookie Error');
    }
    return false;
  });

  /**
   * 初始化秘钥方法
   * @returns boolean 是否初始化成功
   */
  private _checkCryptKeys = pipeline(async (scene: string) => {
    try {
      const initKeys = this._getInitKeys(scene);
      const init_values = await this._storeSDK?.getItems(initKeys);
      const crypt_data = init_values && init_values[cryptCacheKey];
      this._initData = init_values || {};
      if (crypt_data && typeof crypt_data === 'string') {
        try {
          const crypt = JSON.parse(crypt_data);
          const { ec_privateKey, ec_publicKey, ec_csr } = crypt || {};
          if (!ec_privateKey || !ec_publicKey || (this.initType === 'cert' && !ec_csr)) {
            this._initData = {};
            this.emit('load', { action: 'keys', op: 'check', status: 'fail' });
            const result = await this._initCert();
            return result;
          }
          this.cryptoSDK = new SecurityCrypto({ privateKey: ec_privateKey, publicKey: ec_publicKey });
          this._cryptObject = crypt;
          this._cryptData = crypt_data;
          this.emit('load', {
            action: 'sdk',
            op: 'init',
            duration: this.getPerfomanceTimes(),
            status: 'success'
          });
          // this.emit('load', { action: 'keys', op: 'check', status: 'success' });
          return true;
        } catch (error) {
          this.emit('load', { action: 'keys', op: 'check', status: 'fail' });
          this.emit('error', { error, name: 'check crypt data error' });
          this._initData = {};
          const result = await this._initCert();
          return result;
        }
      }
      const result = await this._initCert();
      // this.emit('load', { action: 'keys', op: 'check', status: 'fail' });
      this.emit('load', {
        action: 'sdk',
        op: 'init',
        duration: this.getPerfomanceTimes(),
        status: 'success'
      });
      return result;
    } catch (error) {
      this.emit('load', { action: 'sdk', op: 'init', status: 'fail' });
      this.reportError(error, 'check_crypt_keys_error');
      return false;
    }
  });

  /**
   * 获取当前时间
   * @returns number
   */
  private getPerfomanceTimes = () => {
    let times = 0;
    try {
      times = window.performance?.now() || new Date().getTime();
      return times;
    } catch (error) {}
    return times;
  };

  /**
   * 获取当前初始化秘钥
   * @returns 当前init key  string[]
   */
  private _getInitKeys = (scene: string) => {
    try {
      const keys: string[] = [cryptCacheKey, certificateCacheKey];
      if (scene) {
        const signDataKey = `${signDataCacheKey}/${scene}`;
        keys.push(signDataKey);
      }
      return keys;
    } catch (error) {
      this.emit('error', { error, name: 'get init keys error' });
    }
    return [cryptCacheKey, certificateCacheKey];
  };

  /**
   * process client cookie
   * 设置当前的clientDataCookie 通过该cookie和服务端交互
   */
  private _processCookie = async (scene: string) => {
    // TODO: 是否需要每次都设置且设置Cert, 咨询现在可信登录是否绑定的公钥
    try {
      await this._checkCryptKeys(scene);
      // 未处理serverData Cookie、 检测一下 当前Cookie 是否和当前取到的相同
      if (!this._hasProcessServerData || this.initType === 'pubKey') {
        await this.checkCookieMd5(scene);
      }

      // 新增同步时机
      this._storeSDK?.startStorageChecker?.();

      const { ec_privateKey, ec_csr } = this._cryptObject || {};
      if ((this.initType === 'cert' && !ec_csr) || !ec_privateKey) {
        return;
      }

      const cryptoKeys = await this.cryptoSDK?.getKeys();
      let b64PubKey = cryptoKeys?.publicRawKeyBase64;
      debug('getPubKeyBase64 from raw', b64PubKey);
      if (!b64PubKey) {
        b64PubKey = getPubKeyBase64(ec_privateKey) || '';
        debug('getPubKeyBase64 from method', b64PubKey);
      }
      // const cert = this._initData?.[certificateCacheKey];
      // const checkRes = this._checkCert(cert);
      const certHeader =
        this.initType === 'cert'
          ? {
              'tt-ticket-guard-client-csr': ec_csr || ''
            }
          : {
              // 仅采用公钥版本，2023年07月22日
              'tt-ticket-guard-public-key': b64PubKey,
              'tt-ticket-guard-web-version': 1
            };
      const cookieData = {
        'tt-ticket-guard-version': 2,
        'tt-ticket-guard-iteration-version': 1,
        ...certHeader
      };
      const cookieString = convertStringToBase64(JSON.stringify(cookieData));
      // 先删再设置clientData cookie 防止出现对个域名下的clientdata cookie
      this.cookieOperate?.deleteAllCookie('tt_ticket_guard_client_data');
      // 存在二级域名
      this.cookieOperate?.setCookieWithDomain('tt_ticket_guard_client_data', cookieString);

      this.cookieOperate?.setCookieWithDomain('tt_ticket_guard_client_web_domain', '2');
      // setCookie('tt_ticket_guard_client_data', cookieString);
      // TODO: 设置为2级域名下，后期直播上线，需要修改为二级域名下共享
      // TODO: 同时需要增加逻辑，校验cookies中的公钥是否与私钥生成的一致，后期补充，此部分代码可优化
      // setCookieWithDomain('tt_ticket_guard_client_data', cookieString);
      this.emit('execute', { action: 'cookie', op: 'setItem', status: 'success', ctx: { type: 'client' } });
      // 待排查 达标删除 预期8月底删除
      this.emit('log', {
        extra: { cookie: this.cookieOperate?.getCookie('tt_ticket_guard_client_data') || '', cookieString },
        content: 'set client data success',
        level: 'info'
      });
    } catch (error) {
      this.emit('log', {
        extra: { cookie: this.cookieOperate?.getCookie('tt_ticket_guard_client_data') || '' },
        content: 'process client cookie error',
        level: 'error'
      });
      this.reportError(error, 'Process Cookie Error');
      this.emit('execute', { action: 'cookie', op: 'setItem', status: 'fail', ctx: { type: 'client' } });
    }
  };

  /**
   * 检查当前的md5， 只有在certType === 'cookie'的时候才会检查
   * @returns Promise<void>
   */
  checkCookieMd5 = async (scene: string) => {
    try {
      // const cookiCrypt = getCookie(COOKIE_CRYPT) || '';
      const cookiCrypt = this.cookieOperate?.getCookie(COOKIE_CRYPT) || '';
      if (!cookiCrypt) {
        return false;
      }
      // 1. 检测当前初始化获取的数据是否满足
      const initCorrect = compareAllKeysInfoMD5(
        cookiCrypt,
        this._cryptData,
        this._initData[certificateCacheKey],
        this._initData[`${signDataCacheKey}/${scene}`]
      );
      if (initCorrect) {
        const keys = [cryptCacheKey, certificateCacheKey, `${signDataCacheKey}/${scene}`];
        const values = [
          this._cryptData || '',
          this._initData[certificateCacheKey] || '',
          this._initData[`${signDataCacheKey}/${scene}`] || ''
        ];
        // 校验成功 从iframe 存储成功之后， 回读一下 是否能获取到数据 再和cookie md5对比
        this.loadIframePromise
          ?.then(() =>
            this._storeSDK?.setItems(keys, values, 2).then((res) => {
              const { cross = '0' } = res || {};
              return this._storeSDK?.getItems(keys).then((callback) => {
                // const callbackCyrptCookie = getCookie(COOKIE_CRYPT) || '';
                const callbackCyrptCookie = this.cookieOperate?.getCookie(COOKIE_CRYPT) || '';
                const callbackCorrect = compareAllKeysInfoMD5(
                  callbackCyrptCookie,
                  callback?.[cryptCacheKey],
                  callback?.[certificateCacheKey],
                  callback?.[`${signDataCacheKey}/${scene}`]
                );

                this.emit('load', {
                  action: 'cookie',
                  op: 'process',
                  status: 'success',
                  ctx: { type: '1', scene: 'callback', correct: callbackCorrect ? '1' : '0', cross }
                });
              });
            })
          )
          .catch((err) => {
            this.emit('load', {
              action: 'cookie',
              op: 'process',
              status: 'fail',
              ctx: { type: '1', scene: 'callback' }
            });
            this.emit('error', { error: err, name: 'async data fail' });
          });

        this.emit('load', {
          action: 'cookie',
          op: 'process',
          status: 'success',
          ctx: { type: '1' }
        });
        this.initMatch = true;
        return;
      }
      // 2. 检测当前webStorage 和 cookieStatus 是否对得上
      const localCrypt = await this._storeSDK?.getLocalItem(cryptCacheKey);
      const localCorrect = compareAllKeysInfoMD5(
        cookiCrypt,
        localCrypt,
        this._initData?.[certificateCacheKey] || '',
        this._initData?.[`${signDataCacheKey}/${scene}`] || ''
      );
      if (localCorrect) {
        const keys = [cryptCacheKey, certificateCacheKey, `${signDataCacheKey}/${scene}`];
        const values = [
          localCrypt || '',
          this._initData[certificateCacheKey] || '',
          this._initData[`${signDataCacheKey}/${scene}`] || ''
        ];
        this._processCryptData(localCrypt, 'check cookie md5 error');
        // 不能等
        // 存储成功之后， 回读一下 是否能获取到数据 再和cookie md5对比
        this.loadIframePromise
          ?.then(() =>
            this._storeSDK?.setItems(keys, values, 2).then((res) => {
              const { cross = '0' } = res || {};
              return this._storeSDK?.getItems(keys).then((callback) => {
                // const callbackCyrptCookie = getCookie(COOKIE_CRYPT) || '';
                const callbackCyrptCookie = this.cookieOperate?.getCookie(COOKIE_CRYPT) || '';
                const callbackCorrect = compareAllKeysInfoMD5(
                  callbackCyrptCookie,
                  callback?.[cryptCacheKey],
                  callback?.[certificateCacheKey],
                  callback?.[`${signDataCacheKey}/${scene}`]
                );

                this.emit('load', {
                  action: 'cookie',
                  op: 'process',
                  status: 'success',
                  ctx: { type: '2', scene: 'callback', correct: callbackCorrect ? '1' : '0', cross }
                });
              });
            })
          )
          .catch((err) => {
            this.emit('load', {
              action: 'cookie',
              op: 'process',
              status: 'fail',
              ctx: { type: '2', scene: 'callback' }
            });
            this.emit('error', { error: err, name: 'async data fail' });
          });

        this.emit('load', {
          action: 'cookie',
          op: 'process',
          status: 'success',
          ctx: { type: '2' }
        });
        this.initMatch = true;
        return;
      }
      // 3. 检测当前webStroage数据是否对得上
      const initKeys = this._getInitKeys(scene);
      const localData = await this._storeSDK?.getLocalItems(initKeys);
      const localDataCorrect = compareAllKeysInfoMD5(
        cookiCrypt,
        localData?.[cryptCacheKey],
        localData?.[certificateCacheKey],
        localData?.[`${signDataCacheKey}/${scene}`]
      );
      if (localDataCorrect) {
        const keys = [cryptCacheKey, certificateCacheKey, `${signDataCacheKey}/${scene}`];
        const values = [
          localData?.[cryptCacheKey],
          localData?.[certificateCacheKey],
          localData?.[`${signDataCacheKey}/${scene}`]
        ];
        this._processCryptData(localData?.[cryptCacheKey] || '', 'check cookie md5 error');

        // 存储成功之后， 回读一下 是否能获取到数据 再和cookie md5对比
        this.loadIframePromise
          ?.then(() =>
            this._storeSDK?.setItems(keys, values, 2).then((res) => {
              const { cross = '0' } = res || {};
              return this._storeSDK?.getItems(keys).then((callback) => {
                // const callbackCyrptCookie = getCookie(COOKIE_CRYPT) || '';
                const callbackCyrptCookie = this.cookieOperate?.getCookie(COOKIE_CRYPT) || '';
                const callbackCorrect = compareAllKeysInfoMD5(
                  callbackCyrptCookie,
                  callback?.[cryptCacheKey],
                  callback?.[certificateCacheKey],
                  callback?.[`${signDataCacheKey}/${scene}`]
                );

                this.emit('load', {
                  action: 'cookie',
                  op: 'process',
                  status: 'success',
                  ctx: { type: '3', scene: 'callback', correct: callbackCorrect ? '1' : '0', cross }
                });
              });
            })
          )
          .catch((err) => {
            this.emit('load', {
              action: 'cookie',
              op: 'process',
              status: 'fail',
              ctx: { type: '3', scene: 'callback' }
            });
            this.emit('error', { error: err, name: 'async data fail' });
          });

        this.emit('load', {
          action: 'cookie',
          op: 'process',
          status: 'success',
          ctx: { type: '3' }
        });
        this.initMatch = true;
        return;
      }

      this.emit('load', {
        action: 'cookie',
        op: 'process',
        status: 'fail'
      });
    } catch (error) {
      this.emit('error', { error, name: 'check cookie md5 fail' });
    }
  };

  /**
   * 处理当前数据
   * @param cryptData 当前秘钥数据
   * @param errorMessage errorMessage 报错内容
   * @returns
   */
  _processCryptData = (cryptData?: string, errorMessage?: string) => {
    try {
      if (!cryptData || typeof cryptData !== 'string') {
        return;
      }
      const crypt = JSON.parse(cryptData);
      const { ec_privateKey, ec_publicKey, ec_csr } = crypt || {};
      this._cryptData = cryptData;
      this._initData[cryptCacheKey] = cryptData;
      this._cryptObject = crypt;
      this.cryptoSDK = new SecurityCrypto({ privateKey: ec_privateKey, publicKey: ec_publicKey });
    } catch (error) {
      this.emit('error', { error, name: errorMessage || 'process crypt data error' });
    }
  };

  /**
   * 比较处理serverData 数据，确定是否需要再次处理serverData
   * @param serverData 当前cookie的serverData数据
   * @param cacheData 当前缓存的serverData数据
   * @returns boolean 是否一样
   */
  _compareCookieWithCache = (serverData?: string, cacheData?: string) => {
    if (!cacheData || !serverData) {
      return false;
    }
    if (cacheData === serverData) {
      return true;
    }
    return false;
  };

  /**
   * process serverCookie 处理当前的serverCookie
   * 初始化的时候会处理，获取票据和sign的时候也会处理
   * TODO: 由于以后不会删除cookies，所以每次初始化，加签等操作都会执行processServerCookies的操作，可能存在性能瓶颈，初期不做优化
   * TODO: 后期需增加逻辑，如果serverData保持一致，则放过，做性能优化；获取数据优先级，cookie > storage
   */
  private _processServerCookie = async (scene: string): Promise<any> => {
    try {
      await this._checkCryptKeys(scene);
      // const serverData = getCookie('tt_ticket_guard_server_data') || '';

      const tmp = await this._storeSDK?.getItems([`${signDataCacheKey}/${scene}`]);

      const serverData1 = this.cookieOperate?.getCookie('tt_ticket_guard_server_data') || '';

      const serverData2 = getCookie('tt_ticket_guard_server_data') || '';

      if (serverData1 || serverData2) {
        this.emit('log', {
          extra: {
            cookie: serverData1,
            cookie2: serverData2,
            docCookie: document?.cookie || '',
            lost: serverData1 && serverData2 ? '0' : '1'
          },
          content: 'get_cookie_two',
          level: 'info'
        });
      }

      const serverData = serverData1 || serverData2;
      debug('get cookie server_data', { serverData }, { storage: tmp?.[`${signDataCacheKey}/${scene}`] });

      // const webDomain = getCookie('tt_ticket_guard_web_domain') || '';
      const webDomain = this.cookieOperate?.getCookie('tt_ticket_guard_web_domain') || '';
      // 上报login status 删除  2023年08月01日11:34:06
      // this.checkLoginStatus(serverData);

      if (webDomain) {
        this.emit('execute', {
          op: 'check',
          action: 'server_data',
          status: 'success',
          ctx: {
            server: serverData ? '1' : '0',
            server2: serverData2 ? '1' : '0',
            domain: webDomain
          }
        });
        // setCookieWithDomain(COOKIE_DOMAIN, webDomain);
        this.cookieOperate?.setCookieWithDomain(COOKIE_DOMAIN, webDomain);
      }

      const is_use_session_for_ticket = false;
      let is_store_to_storage_success = false;
      const processStartTime = new Date().getTime();
      let server: Record<string, string> = {};
      if (serverData) {
        const encodingData = decodeURIComponent(serverData);
        const utf8Data = convertBase64ToString(encodingData);
        server = JSON.parse(utf8Data);
      }

      if (server.ticket) {
        const keys = [`${signDataCacheKey}/${scene}`];
        // cross origin storage, 由于ticket是复用sessionid，为了安全考虑，不将ticket存储在storage中
        const { ticket, ...rest } = server;
        let data = { ...server };
        const encryptTicket = await encryptText(ticket);

        if (encryptTicket) {
          data = {
            ...rest,
            encrypt_ticket: encryptTicket
          };
        }

        const values = [JSON.stringify(data)];
        // do not need to support client_cert
        try {
          await this._storeSDK?.setItems(keys, values);
          is_store_to_storage_success = true;
        } catch (e) {
          is_store_to_storage_success = false;
        }
        debug('storage cookie server_data', is_store_to_storage_success);
        if (is_store_to_storage_success) {
          this.cookieOperate?.deleteAllCookie('tt_ticket_guard_server_data');
          // webDomain && deleteCookie('tt_ticket_guard_web_domain');
          webDomain && this.cookieOperate?.deleteAllCookie('tt_ticket_guard_web_domain');

          const deleteStatus = this.cookieOperate?.getCookie('tt_ticket_guard_server_data') ? '0' : '1';
          const processEndTime = new Date().getTime();
          this.emit('execute', {
            action: 'cookie',
            op: 'setItem',
            status: 'success',
            duration: processEndTime > processStartTime ? processEndTime - processStartTime : 0,
            ctx: { type: 'server', deleteStatus }
          });
          // await this._processCookie();
          try {
            this.emit('execute', { action: 'cookie', op: 'process', status: 'success' });
          } catch (error) {
            this.emit('execute', { action: 'cookie', op: 'process', status: 'fail' });
            this.emit('log', {
              content: 'set process server cookie error',
              level: 'error'
            });
          }
          // this._serverDataCache = serverData;
          this._hasProcessServerData = true;
        }
      } else if (webDomain) {
        // deleteCookie('tt_ticket_guard_web_domain');
        this.cookieOperate?.deleteAllCookie('tt_ticket_guard_web_domain');
        this.emit('log', {
          content: 'process_web_domain',
          level: 'info',
          extra: {
            cookie: document?.cookie || '',
            // domain: getCookie('tt_ticket_guard_web_domain') || '',
            domain: this.cookieOperate?.getCookie('tt_ticket_guard_web_domain') || ''
          }
        });
      }
      const is_server_data_exist_from_cookie = Boolean(serverData);
      const is_origin_store_exist = Boolean(tmp?.[`${signDataCacheKey}/${scene}`]);
      if (is_server_data_exist_from_cookie || is_use_session_for_ticket) {
        logFetchServerDataFromCookie({
          is_origin_store_exist,
          is_server_data_exist_from_cookie,
          is_use_session_for_ticket,
          is_store_to_storage_success
        });
      }
      return true;
    } catch (error) {
      this.emit('log', {
        extra: { cookie: document?.cookie },
        content: 'Process server Cookie Error',
        level: 'error'
      });
      this.reportError(error, 'process server cookie Error');
      this.emit('execute', { action: 'cookie', op: 'setItem', status: 'fail', ctx: { type: 'server' } });
    }
    return false;
  };

  /**
   * 获取当前cert certType 为header时不会走到这个逻辑
   * @returns boolean true 为成功 false为失败
   */
  private _initCert = async () => {
    try {
      // storage 中有则复用，没有则生成
      const storage_crypt = await this._storeSDK?.getLocalItem(cryptCacheKey);
      if (storage_crypt && typeof storage_crypt === 'string') {
        this._cryptData = storage_crypt;
        this._cryptObject = JSON.parse(storage_crypt);
        this.cryptoSDK = new SecurityCrypto({
          privateKey: this._cryptObject?.ec_privateKey,
          publicKey: this._cryptObject?.ec_publicKey
        });
        this._initData = { cryptCacheKey: storage_crypt };
        this.emit('ready', { action: 'keys', op: 'init', status: 'fail', ctx: { type: 'check' } });
        return true;
      }
      const { ec_privateKey, ec_publicKey, ec_csr } = await this._getCertificatePem();

      this._cryptObject = { ec_privateKey, ec_publicKey, ec_csr };
      this._cryptData = JSON.stringify(this._cryptObject);
      // 生成完之后存到当前域名下的localStorage 和indexedDB中
      await this._storeSDK?.setLocalItem(cryptCacheKey, this._cryptData);
      // 存完local 再存iframe 为了兼容sso，sso登录的时候需要把私钥传递给iframe
      await this._storeSDK?.set(cryptCacheKey, this._cryptData);
      this._initData = { cryptCacheKey: this._cryptData };
      return true;
    } catch (error) {
      this.emit('load', {
        action: 'keys',
        op: 'init',
        status: 'fail'
      });
      this.reportError(error, 'init_cert_error');
      return false;
    }
  };

  /**
   * 获取当前证书签名 如果certType 传的是request 使用这个方法获取证书 如果设置certType === 'header' & storageType === 'local' 那 use {@link getCertificateSync}
   * @param params { certType: string; scene: string } certType证书类型， scene当前场景
   * 如果是证书加签，直接返回证书，如果是公钥加签，直接返回公钥
   * @returns Promise<string | false>表示生成证书失败 string(base64)表示成功 （可查看localStorage 或者其他存储 是否包含公私钥
   */
  getCertificate = async (params: { certType: string; scene: string }): Promise<string | false> => {
    const { certType, scene } = params;
    try {
      await this._checkCryptKeys(scene);
      if (certType === 'cookie') {
        await this._initCookie();
        await this._processServerCookie(scene);
      }
      // await this._initCookie();
      await this.setSignValueScheduler?.wait();
      // 获取ts_sign
      // const ts_sign = await this.getTSSign({
      //   certType,
      //   scene,
      // });

      // TODO: 如果是公钥加签，直接从私钥中解析出公钥，字节码转base64，开头为`pub.`，本期采用storage中返回字段
      // if (isPublishKeySign(ts_sign || '') && this.signType === 'pubKey') {
      //   const pubKey = await this._storeSDK?.get(certificateCacheKey);
      //   if (pubKey) {
      //     return convertStringToBase64(pubKey);
      //   }
      //   this.emit('ready', { action: 'cert', op: 'getItem', status: 'fail' });
      //   return false;
      // }

      const cert = await this._storeSDK?.get(certificateCacheKey);
      if (cert) {
        this.emit('log', {
          extra: { cert: cert || '' },
          content: 'Get Cert Success',
          level: 'info'
        });
        // this.emit('ready', { action: 'cert', op: 'getItem', status: 'success' });
        return convertStringToBase64(cert);
      }
      // this.emit('ready', { action: 'cert', op: 'getItem', status: 'fail' });
      this.emit('log', {
        extra: { cert: cert || '' },
        content: 'Get Cert Fail',
        level: 'info'
      });
      return false;
    } catch (error) {
      this.reportError(error, 'get cert fail');
    }
    return false;
  };

  /**
   *  setSignValue in iframe
   * @param sign 当前sign数据
   * @param scene  scene 场景
   * @returns Boolean
   */
  private _signValueWithIframe = async (sign: string, scene: string, namespace?: string) => {
    try {
      const server_data = JSON.parse(sign);
      const { client_cert } = server_data || {};
      // 是否不存在signData, 是的话就不用存储了,内存一定放一份
      if (!this._disableStorageSignData) {
        await this._storeSDK?.set(`${signDataCacheKey}/${scene}`, sign);
      }
      this._signData = sign;
      // let certKey = certificateCacheKey;
      if (namespace) {
        // certKey = `${certKey}/${namespace}`;
        // 个人觉得不需要 sso登录 一定刷新子站点登录态 生成的cert一定是新版,所以直接存起来 用一个namespace作为标识
        client_cert && (await this._storeSDK?.set(`${certificateCacheKey}`, client_cert));
      }
      // TODO: 2023年10月25日16:16:41放开，想着除了cookie方案统一 其他方案证书其他全部数据隔离
      if (this._storageNamespace) {
        client_cert && (await this._storeSDK?.set(`${certificateCacheKey}`, client_cert));
      }
      return true;
    } catch (error) {
      this.reportError(error, 'sign value error');
      return false;
    }
  };

  /**
   * 传参当前ts_sign 获取ticket时从可信lib 获取的数据
   * @param params object: sign object | base64str 服务端返回是base64 就传base64 返回的是对象就按照格式传对象 scene: 当前场景
   * @returns string | false false 标识base64解码失败 string 当前需要防护的数据
   */
  setSignValue = (params: { sign: SignValueProps | string; scene: string; namespace?: string }): boolean => {
    const { sign, scene, namespace } = params || {};
    let sign_data: string;
    try {
      if (typeof sign === 'string') {
        sign_data = convertBase64ToString(sign);
      } else if (typeof sign === 'object') {
        sign_data = JSON.stringify(sign);
      } else {
        return false;
      }
      this.setSignValueScheduler?.provider(() => this._signValueWithIframe(sign_data, scene, namespace));
      // this.emit('ready', { action: 'server_data', op: 'setItem', status: 'success', ctx: { type: 'setsign' } });
      return true;
    } catch (error) {
      // this.emit('ready', { action: 'server_data', op: 'setItem', status: 'fail', ctx: { type: 'setsign' } });
      this.reportError(error, 'set signValue Error');
      return false;
    }
  };

  /**
   * 传参当前ts_sign 获取ticket时从可信lib 获取的数据
   * @param params object: sign object | base64str 服务端返回是base64 就传base64 返回的是对象就按照格式传对象 scene: 当前场景
   * @returns string | false false 标识base64解码失败 string 当前需要防护的数据
   */
  setSignValueAsync = async (params: {
    sign: SignValueProps | string;
    scene: string;
    namespace?: string;
  }): Promise<boolean> => {
    const { sign, scene, namespace } = params || {};
    let sign_data: string;
    try {
      if (typeof sign === 'string') {
        sign_data = convertBase64ToString(sign);
      } else if (typeof sign === 'object') {
        sign_data = JSON.stringify(sign);
      } else {
        return false;
      }
      await this._signValueWithIframe(sign_data, scene, namespace);
      // this.emit('ready', { action: 'server_data', op: 'setItem', status: 'success', ctx: { type: 'setsign' } });
      return true;
    } catch (error) {
      // this.emit('ready', { action: 'server_data', op: 'setItem', status: 'fail', ctx: { type: 'setsign' } });
      this.reportError(error, 'set signValue Error');
      return false;
    }
  };

  /**
   * 删除当前防护数据 例如ticket 更换之后需要调用该方法
   */
  clearSignData = async (scene: string) => {
    try {
      await this._storeSDK?.delete(`${signDataCacheKey}/${scene}`);
      this._signData = '';
      if (this._storageNamespace) {
        await this._storeSDK?.delete(`${certificateCacheKey}`);
      }
      return true;
    } catch (error) {
      return false;
    }
  };

  /**
   * sign request data
   * @param params sign_data: need sign data 如果不传则使用ts_sign内防护的ticket req_content: need sign content 需要加签的数据 timestamp: 当前时间戳 certType: 当前cert类型 scene: 当前场景
   * @returns string base64编码的数据，数据内部包含ts_sign， req_content req_sign
   */
  sign = async (params: {
    sign_data?: string;
    req_content?: string;
    timestamp?: number;
    certType: string;
    scene: string;
  }): Promise<string> => {
    const { sign_data, req_content, timestamp, certType = 'header', scene } = params;
    try {
      await this._checkCryptKeys(scene);
      if (certType === 'cookie') {
        await this._initCookie();
        await this._processServerCookie(scene || '');
      }
      if (certType === 'header') {
        await this.setSignValueScheduler?.wait();
      }
      /**
       * 1. 判断是否需要存储当前signData
       * 2. 需要走原来逻辑
       * 3. 不需要走新逻辑
       */

      let storage_sign_data;
      if (!this._disableStorageSignData) {
        storage_sign_data = await this._storeSDK?.get(`${signDataCacheKey}/${scene}`);
        // 感觉storage_sign_data不存在 也不影响原子能力传入sign_data 加签
        // if (!storage_sign_data) {
        //   // this.emit('ready', { action: 'server_data', op: 'getItem', status: 'fail', ctx: { type: 'sign' } });
        //   this.emit('log', {
        //     extra: { content: 'storage sign data is null' },
        //     content: 'sign data fail',
        //     level: 'info',
        //   });
        //   return '';
        // }
      } else {
        storage_sign_data = this._signData;
      }
      const { ticket, ts_sign } = JSON.parse(storage_sign_data || '{}');
      if (!sign_data && !ticket) {
        // this.emit('ready', { action: 'server_data', op: 'getItem', status: 'fail', ctx: { type: 'sign' } });
        this.emit('log', {
          extra: { content: 'sign_data and ticket is null' },
          content: 'sign data fail',
          level: 'info'
        });
        return '';
      }
      const sig_data = await this.cryptoSDK?.sign(sign_data || ticket);
      const base64_sign_data = convertHexToBase64(sig_data || '');
      const sign_obj = {
        ts_sign,
        req_content: req_content || sign_data || ticket,
        req_sign: base64_sign_data,
        timestamp: timestamp || Math.floor(new Date().getTime() / 1000)
      };
      this.emit('log', {
        extra: { content: JSON.stringify(sign_obj) },
        content: 'sign data success',
        level: 'info'
      });
      // this.emit('ready', { action: 'server_data', op: 'getItem', status: 'success', ctx: { type: 'sign' } });
      return convertStringToBase64(JSON.stringify(sign_obj) || '');
    } catch (error) {
      this.emit('log', {
        extra: {
          sign_data: sign_data || '',
          req_content: req_content || '',
          certType: certType || '',
          scene: scene || ''
        },
        content: 'sign data is error',
        level: 'error'
      });
      this.reportError(error, 'sign error');
    }
    return '';
  };

  /**
   * 简单加签数据
   * @param data 需要加签的数据
   * @returns base64 string sign_data
   */
  pureSign = async (data: string) => {
    try {
      const sig_data = await this.cryptoSDK?.sign(data);
      const base64_sign_data = convertHexToBase64(sig_data || '');
      return base64_sign_data;
    } catch (error) {
      this.reportError(error, 'pure sign fail');
      return '';
    }
  };

  /**
   * 获取当前ts_sign
   * @param params { certType: string; scene: string }
   * @returns string 为ts_sign false 获取失败
   */
  getTSSign = async (params: { certType: string; scene: string }): Promise<string | false> => {
    const { certType = 'header', scene } = params;
    try {
      await this._checkCryptKeys(scene);
      if (certType === 'cookie') {
        await this._initCookie();
        await this._processServerCookie(scene);
      }
      if (certType === 'header') {
        await this.setSignValueScheduler?.wait();
      }
      let storage_sign_data;
      if (!this._disableStorageSignData) {
        storage_sign_data = await this._storeSDK?.get(`${signDataCacheKey}/${scene}`);
        if (!storage_sign_data) {
          this.emit('log', {
            extra: { content: storage_sign_data || '' },
            content: 'get tssign fail',
            level: 'info'
          });
          return false;
        }
      } else {
        storage_sign_data = this._signData;
      }
      const { ts_sign } = JSON.parse(storage_sign_data || '{}');
      this.emit('log', {
        extra: { content: ts_sign || '' },
        content: 'get tssign success',
        level: 'info'
      });
      return ts_sign;
    } catch (error) {
      this.reportError(error, 'get ts sign Error');
    }
    return false;
  };

  /**
   * 获取当前防护的数据 例如token 当加签失败的时候 可以校验当前业务token 和 可信防护token 是否一致 不一致
   * @param params: { scene: string { certType: string; scene: string }
   * @returns string 当前防护数据
   */
  getTicket = async (params: { certType: string; scene: string }): Promise<string | false> => {
    const { certType, scene } = params;
    try {
      await this._checkCryptKeys(scene);
      if (certType === 'cookie') {
        await this._initCookie();
        await this._processServerCookie(scene);
      } else if (certType === 'header') {
        await this.setSignValueScheduler?.wait();
      }

      let storage_sign_data;
      if (!this._disableStorageSignData) {
        storage_sign_data = await this._storeSDK?.get(`${signDataCacheKey}/${scene}`);
        if (!storage_sign_data) {
          this.emit('log', {
            content: 'Get Ticket Fail',
            level: 'error'
          });
          return false;
        }
      } else {
        storage_sign_data = this._signData;
      }
      const { ticket } = JSON.parse(storage_sign_data || '{}') || {};
      this.emit('log', {
        extra: { storage_sign_data: storage_sign_data || '', ticket: ticket || '' },
        content: 'Get Ticket Success',
        level: 'info'
      });
      return ticket;
    } catch (error) {
      this.reportError(error, 'Get Ticket Error');
      return false;
    }
  };

  /**
   * 生成公私钥 + csr pem 方法
   * @returns object publicKey & privateKey & csr pem
   */
  _getCertificatePem = async (): Promise<CryptoValues> => {
    const startTimes = new Date().getTime();
    this.cryptoSDK = new SecurityCrypto({});
    const { publicKey = '', privateKey = '' } = await this.cryptoSDK?.getKeys();
    // csr 没有必要
    // const csr = this.cryptoSDK?.getCSR();

    const endTimes = new Date().getTime();
    this.emit('load', {
      action: 'keys',
      op: 'init',
      duration: endTimes > startTimes ? endTimes - startTimes : 0,
      status: 'success',
      ctx: { pri: privateKey ? '1' : '0', pub: publicKey ? '1' : '0' }
    });
    return { ec_publicKey: publicKey, ec_privateKey: privateKey, ec_csr: '' };
  };

  /**
   * 检查当前证书是否和当前密钥对匹配, 匹配返回true，不匹配则返回false 生成cookie使用 (已废弃)
   * @deprecated
   * @returns boolean
   */
  _checkCert = (cert?: string) => {
    try {
      const { ec_publicKey } = this._cryptObject || {};
      if (!cert || !ec_publicKey) {
        return true;
      }
      const _public_key = getPublicKeyFromCert(cert);
      // 如果相同就没事 不相同 删除当前cert
      if (_public_key && ec_publicKey !== _public_key) {
        this.emit('log', {
          extra: {
            message: 'Cert Fail Delete',
            localCert: cert || '',
            ec_publicKey: ec_publicKey || ''
          },
          content: 'Cert Fail Delete',
          level: 'error'
        });
        this.emit('ready', { action: 'cert', op: 'check', status: 'fail' });
        return false;
      }
      this.emit('ready', { action: 'cert', op: 'check', status: 'success' });
      return true;
    } catch (error) {
      this.emit('ready', { action: 'cert', op: 'check', status: 'fail' });
      this.reportError(error, 'Check Cert fail');
    }
    return true;
  };

  /**
   * 刷新当前的密钥对+证书 多个业务共用SDK的话 尽量少使用当前refresh方法 可能会导致其他业务防护失效的问题
   * @returns true or false
   */
  refresh = async () => {
    // TODO: 后续思考refresh这种操作是否需要保留
    // this._requestCertPromise = undefined;
    // this._processCookiePromise = undefined;
    // this._checkCryptStatus = undefined;
    this._cryptData = undefined;
    this._cryptObject = undefined;
    this._signData = undefined;
    await this._storeSDK?.delete(cryptCacheKey);
    await this._storeSDK?.delete(certificateCacheKey);
    this._storeSDK = undefined;
    return this.start();
  };

  reportError = (error: unknown, name: string, action?: TypeAction, type?: TypeOperate, params?: any) => {
    try {
      this.emit('error', { error, name });
      if (action && type) {
        const key = Array.isArray(params) && params.length > 0 && params[0];
        if (typeof key === 'string') {
          // this.emit('execute', { action, op: type, status: 'fail', ctx: { key: key || '' } });
          this.emit('log', { content: 'report error', extra: { key: key || '' }, level: 'error' });
        } else if (key && Array.isArray(key)) {
          const ctx: { [key: string]: string } = {};
          key.forEach((ele) => {
            ctx[`${ele.replace(/\//g, '_')}`] = '1';
          });
          // this.emit('execute', { action, op: type, status: 'fail', ctx });)
          this.emit('log', { content: 'report error', extra: { ...(ctx || {}) }, level: 'error' });
        }
      }
    } catch (err) {
      this.emit('error', { error: err, name: 'report error' });
    }
  };

  /**
   * 新增统一获取数据入口
   */
  getKeysInfo = async (params: { certType: string; scene: string }): Promise<TypeAllKeysInfo> => {
    const { certType, scene } = params;
    try {
      await this._checkCryptKeys(scene);
      if (certType === 'cookie') {
        await this._initCookie();
        await this._processServerCookie(scene);
      } else if (certType === 'header') {
        await this.setSignValueScheduler?.wait();
      }
      const keys = [cryptCacheKey, certificateCacheKey, `${signDataCacheKey}/${scene}`];
      const values = await this._storeSDK?.getItems(keys);
      if (!values) {
        this.emit('log', {
          content: 'Get Keys Info Fail',
          level: 'error'
        });
        // this.emit('execute', { action: 'keys', op: 'getKeys', status: 'fail' });
        return {};
      }
      const crypt_data = values[cryptCacheKey];
      const cert_data = values[certificateCacheKey];
      const server_data = values[`${signDataCacheKey}/${scene}`];
      const crypt = JSON.parse(crypt_data || '{}');
      const { ec_privateKey, ec_publicKey, ec_csr } = crypt || {};
      const { ticket, ts_sign, client_cert } = JSON.parse(server_data || '{}') || {};
      this.emit('log', {
        extra: { server_data: server_data || '', cert_data: cert_data || '', csr: ec_csr || '' },
        content: 'Get Keys Info Success',
        level: 'info'
      });
      // this.emit('execute', { action: 'keys', op: 'getKeys', status: 'success' });
      return {
        crypt: { ec_privateKey, ec_publicKey },
        cert: cert_data,
        sign: { ticket, ts_sign, client_cert },
        b64Cert: convertStringToBase64(cert_data || ''),
        b64PubKey: convertBase64ToString(ec_publicKey || ''),
        b64Csr: convertStringToBase64(ec_csr || '')
      };
    } catch (error) {
      // this.emit('execute', { action: 'keys', op: 'getKeys', status: 'fail' });
      this.reportError(error, 'Get Ticket Fail');
    }
    return {};
  };

  getKeysInfoWithOrigin = async (params: {
    certType: string;
    scene: string;
    namespace?: string;
  }): Promise<TypeAllKeysInfo> => {
    const { certType, scene, namespace } = params;
    try {
      await this._checkCryptKeys(scene);
      if (certType === 'cookie') {
        await this._initCookie();
        await this._processServerCookie(scene);
      } else if (certType === 'header') {
        await this.setSignValueScheduler?.wait();
      }
      // let certKey = certificateCacheKey;
      // if (namespace) {
      //   certKey = `${certKey}/${namespace}`;
      // }
      const keys = [cryptCacheKey, certificateCacheKey, `${signDataCacheKey}/${scene}`];
      const values = await this._storeSDK?.getItemsWithOrigin(keys);
      debug('[request sign] get from storage', values);

      if (!values) {
        this.emit('log', {
          content: 'Get Keys Info Fail',
          level: 'error'
        });
        // this.emit('execute', { action: 'keys', op: 'getKeys', status: 'fail' });
        return {};
      }
      const { data = {}, from = '0' } = values || {};
      const items = Object.values(data);
      const crypt_data = data[cryptCacheKey];
      const cert_data = data[certificateCacheKey];
      const server_data = data[`${signDataCacheKey}/${scene}`];
      const { value = '' } = crypt_data || {};
      const crypt = JSON.parse(value || '{}');
      const { ec_privateKey, ec_publicKey, ec_csr } = crypt || {};
      const server_data_value = server_data?.value || '';
      const cert_data_value = cert_data?.value || '';
      const {
        ticket: _ticket,
        ts_sign,
        client_cert,
        encrypt_ticket
      } = JSON.parse(server_data_value || '{}') || {};
      let ticket = _ticket;
      if (ticket) {
        // 删除ticket， 重新存储
        const encryptTicket = await encryptText(ticket);

        const _data = {
          ts_sign,
          client_cert,
          encrypt_ticket: encryptTicket
        };
        await this._storeSDK?.setItems([`${signDataCacheKey}/${scene}`], [JSON.stringify(_data)]);
        debug('[request sign] update pure ticket');
      } else if (!ticket && encrypt_ticket) {
        // 应该是没有ticket, 但有encrypt_ticket
        ticket = await decryptText(encrypt_ticket);

        debug('[request sign] encrypt_ticket', encrypt_ticket, 'decrypt_ticket', ticket);
      }

      const cryptoKeys = await this.cryptoSDK?.getKeys();
      let b64PubKey = cryptoKeys?.publicRawKeyBase64;
      debug('getPubKeyBase64 from raw', b64PubKey);
      if (!b64PubKey) {
        b64PubKey = getPubKeyBase64(ec_privateKey) || '';
        debug('getPubKeyBase64 from method', b64PubKey);
      }
      this.emit('log', {
        extra: {
          server_data: server_data_value || '',
          cert_data: cert_data_value || '',
          b64PubKey
        },
        content: 'Get Keys Info Success',
        level: 'info'
      });
      // this.emit('execute', { action: 'keys', op: 'getKeys', status: 'success' });
      return {
        crypt: { ec_privateKey, ec_publicKey },
        cryptData: value,
        cert: cert_data_value,
        sign: { ticket, ts_sign, client_cert },
        b64Cert: convertStringToBase64(cert_data_value || ''),
        b64PubKey,
        b64Csr: convertStringToBase64(ec_csr || ''),
        serverData: server_data_value,
        dataFrom: from,
        items
      };
    } catch (error) {
      // this.emit('execute', { action: 'keys', op: 'getKeys', status: 'fail' });
      this.reportError(error, 'Get Ticket catch');
    }
    return {};
  };

  /**
   * 加签数据 使用getKeysInfo
   * @param params any
   * @returns string
   */
  signWithKeysInfo = async (params: {
    sign_data?: string;
    req_content?: string;
    timestamp?: number;
    certType: string;
    scene: string;
    keysInfo: TypeAllKeysInfo;
  }): Promise<string> => {
    const { sign_data, req_content, timestamp, certType, scene, keysInfo } = params;
    // this.emit('log', {
    //   content: '[signWithKeysInfo] start',
    //   level: 'info',
    // });
    try {
      await this._checkCryptKeys(scene);
      if (certType === 'cookie') {
        // this.emit('log', {
        //   content: '[signWithKeysInfo] cookies check',
        //   level: 'info',
        // });
        await this._initCookie();
        await this._processServerCookie(scene || '');
      }
      if (certType === 'header') {
        await this.setSignValueScheduler?.wait();
      }
      // this.emit('log', {
      //   content: '[signWithKeysInfo] before end',
      //   level: 'info',
      // });
      // const storage_sign_data = await this._storeSDK?.get(`${signDataCacheKey}/${scene}`);
      const { sign, crypt } = keysInfo;
      if (!sign) {
        // this.emit('execute', { action: 'server_data', op: 'sign', status: 'fail' });
        this.emit('log', {
          content: 'sign data fail',
          level: 'info',
          extra: { content: 'sign data is null' }
        });
        return '';
      }
      const { ticket, ts_sign } = sign || {};
      if (!sign_data && !ticket) {
        this.emit('log', {
          content: 'sign data fail',
          level: 'info',
          extra: { content: 'sign data and ticket is null' }
        });
        // this.emit('execute', { action: 'server_data', op: 'sign', status: 'fail' });
        return '';
      }
      const { ec_privateKey, ec_publicKey } = crypt || {};
      this.cryptoSDK = new SecurityCrypto({ privateKey: ec_privateKey, publicKey: ec_publicKey });
      debug('[request sign] before sign with', sign_data, ec_privateKey, ec_publicKey);

      const sig_data = await this.cryptoSDK?.sign(sign_data || ticket);
      debug('[request sign] after sign', sig_data);

      const base64_sign_data = convertHexToBase64(sig_data || '');
      debug('[request sign] after sign base64', base64_sign_data);

      const sign_obj = {
        ts_sign,
        req_content: req_content || sign_data || ticket,
        req_sign: base64_sign_data,
        timestamp: timestamp || Math.floor(new Date().getTime() / 1000)
      };
      debug('crypto sign', {
        type: this.cryptoSDK?.type,
        ec_privateKey,
        ec_publicKey,
        ts_sign,
        req_content,
        before_sign_data: sign_data,
        after_sign_data: sig_data,
        base64_sign_data
      });
      this.emit('log', {
        extra: { content: JSON.stringify(sign_obj) },
        content: 'sign data success',
        level: 'info'
      });
      // this.emit('execute', { action: 'server_data', op: 'sign', status: 'success' });
      return convertStringToBase64(JSON.stringify(sign_obj) || '');
    } catch (error) {
      this.emit('log', {
        extra: {
          sign_data: sign_data || '',
          req_content: req_content || '',
          certType: certType || '',
          scene: scene || '',
          csr: keysInfo?.crypt?.ec_csr || '',
          cert: keysInfo.cert || '',
          sign: keysInfo.sign?.ticket || ''
        },
        content: 'sign data with keys Info is error',
        level: 'error'
      });
      // this.emit('execute', { action: 'server_data', op: 'sign', status: 'fail' });
      this.reportError(error, 'sign error');
    }
    return '';
  };

  /**
   * 同步当前验签成功数据
   * @param keys 当前需要同步的key
   * @param values 当前需要同步的value
   */
  setKeysAndValues = (keys: string[], values: string[], scene: string) => {
    // 1. 存储到iframe内部， 最多重试两次
    let cryptData = '';
    let cert = '';
    let serverData = '';
    this._storeSDK
      ?.setItems(keys, values, 2)
      .then((res) => {
        keys.forEach((ele, index) => {
          const value = values[index];
          if (ele === cryptCacheKey) {
            cryptData = value;
          } else if (ele === certificateCacheKey) {
            cert = value;
          } else if (ele === `${signDataCacheKey}/${scene}`) {
            serverData = value;
          }
        });
        const md5String = generateKeysInfoMD5(cryptData, cert, serverData);
        md5String && this.cookieOperate?.setCookieWithDomain(COOKIE_CRYPT, md5String);
        this.emit('log', {
          extra: {
            md5: md5String,
            md5Cookie: this.cookieOperate?.getCookie(COOKIE_CRYPT) || ''
          },
          content: 'generate crypt key success sign success',
          level: 'info'
        });
        // this.emit('execute', {
        //   action: 'cookie',
        //   op: 'update',
        //   status: 'success',
        //   ctx: { type: 'sign' },
        // });
      })
      .catch((err) => {
        this.emit('error', { error: err, name: 'update keys when sign error' });
      });
  };

  b642str = (str: string) => convertBase64ToString(str);

  getIframeStatus = () => this._storeSDK?.getIframeStatus();

  getCookieCryptStatus = () => {
    const crypt_cookie = this.cookieOperate?.getCookie(COOKIE_CRYPT) || '';
    if (crypt_cookie) {
      return true;
    }
    return false;
  };

  getStorageStatus = () => this._storeSDK?.getStorageStatus();

  /**
   * 判断当前带上的client_data 和iframe 匹配还是说和local匹配
   * @param keysInfo 当前获取的秘钥
   * @returns Promise<object>
   */
  checkSignData = async (keysInfo: TypeAllKeysInfo, scene: string) => {
    try {
      const cookieCrypt = this.cookieOperate?.getCookie(COOKIE_CRYPT) || '';
      if (!cookieCrypt) {
        return {
          match_md5_local: '-99',
          match_md5_iframe: '-99'
        };
      }
      const { cryptData, cert, serverData, dataFrom } = keysInfo || {};

      const signCorrect = compareAllKeysInfoMD5(cookieCrypt, cryptData, cert, serverData);

      const initKeys = this._getInitKeys(scene);
      const localData = await this._storeSDK?.getLocalItems(initKeys);
      const localDataCorrect = compareAllKeysInfoMD5(
        cookieCrypt,
        localData?.[cryptCacheKey],
        localData?.[certificateCacheKey],
        localData?.[`${signDataCacheKey}/${scene}`]
      );

      // 直接判断初始化数据 和 local 获取的数据是否一致
      return {
        match_md5_local: localDataCorrect ? '1' : '-99',
        match_md5_iframe: signCorrect ? '1' : '-99'
      };
    } catch (error) {
      this.emit('error', { error, name: 'check sign data error' });
    }
    return {
      match_md5_local: '-99',
      match_md5_iframe: '-99'
    };
  };

  isTopBrowser = () => isTopBrowser();
}
export { version as __version__ } from '../package.json';
export * from './utils';
export type { SignValueProps };
export default CryptoSDK;
export { encryptText, decryptText } from './crypto/secure-storage';
